import { Image } from "@nextui-org/react";
import { useMemo, useState } from "react";
import { ETHER } from "../../constants/types";
import { useAccount } from "wagmi";

export function TokenLogo({ token, width, height ,style}) {
  const { chainId } = useAccount();
  const [imgSrc, setImgSrc] = useState(null); // State to manage image source

  const tokenSrc = useMemo(() => {
    if (!token || token === ETHER) {
      return `/chains/${chainId}.png`;
    }
    return `/tokens/${token.address}.png`;
  }, [token, chainId]);

  // Default image path
  const defaultImage = "/tokens/default-token.png"; // Replace with your default image path

  // Handle image load error
  const handleImageError = () => {
    setImgSrc(defaultImage);
  };

  return (
    <Image
      height={height} // Fixed prop order (height and width were swapped)
      width={width}
      src={imgSrc || tokenSrc} // Use imgSrc if set (fallback), otherwise tokenSrc
      className="opacity-100"
      radius="full"
      onError={handleImageError} // Set default image on error
      style={style}

    />
  );
}